<ng-container *ngIf="!loadingRow">
  <td class="no-padding" (click)="openInspection()" [@fadeIn]>
    <span class="eval eval--{{inspection.Evaluation | lowercase}}">{{inspection.Evaluation}}</span>
  </td>
  <td (click)="openInspection(inspection)" [@fadeIn]>{{inspection.InspectionDate | date:'dd/MMM/yyyy'}}</td>
  <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.SerialNumber">{{inspection.SerialNumber | truncate:[13]}}</td>
  <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.CustomerName">{{inspection.CustomerName | truncate:[13]}}</td>
  <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.JobsiteName">{{inspection.JobsiteName | truncate:[13]}}</td>
  <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Make">{{inspection.Make | truncate:[13]}}</td>
  <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Model">{{inspection.Model | truncate:[13]}}</td>
  <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Family">{{inspection.Family | truncate:[13]}}</td>
  <td *ngIf="inspection.IsChain==false && inspection.IsFrame==false" (click)="openInspection(inspection)" [@fadeIn] >Idler</td>
  <td *ngIf="inspection.IsChain==true" (click)="openInspection(inspection)" [@fadeIn] >Chain</td>
  <td *ngIf="inspection.IsChain==false &&  inspection.IsFrame==true" (click)="openInspection(inspection)" [@fadeIn] >Frame</td>

  <td (click)="openInspection(inspection)" [@fadeIn]>
    <span>
      {{inspection.Status}}
    </span>
  </td>
</ng-container>
<ng-container *ngIf="loadingRow">
  <td colspan="9">
    <div class="ph-item" style="height: 33px;">
      <div class="ph-row">
        <div class="ph-col-12"></div>
      </div>
    </div>
  </td>
</ng-container>
